import { pxToRem } from "@input-output-hk/px-to-rem";

export const shadows = {
  elevation1: `${pxToRem(1)} ${pxToRem(4)} ${pxToRem(
    18
  )} rgba(26, 52, 185, 0.15)`
} as const;
